import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "./ui/button";

const PageHero = ({ eyebrow, title, sub, image, imageAlt }) => (
  <section className="relative pt-32 pb-20 overflow-hidden bg-gradient-to-b from-slate-50 to-white">
    <div className="absolute inset-0 grid-pattern opacity-60" />
    <div className="absolute -top-32 -right-32 h-96 w-96 rounded-full bg-primary/10 blur-3xl" />
    <div className="container-wide relative grid lg:grid-cols-2 gap-12 items-center">
      <div className="animate-fade-up">
        <span className="inline-block text-xs font-semibold uppercase tracking-[0.18em] text-primary mb-3">
          {eyebrow}
        </span>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900 leading-[1.08] text-balance">
          {title}
        </h1>
        <p className="mt-5 text-lg text-slate-500 leading-relaxed max-w-lg">{sub}</p>
        <Button asChild size="lg" className="mt-8 rounded-lg bg-primary hover:bg-primary/90 shadow-lg shadow-primary/25">
          <a href="#contact">Get in Touch <ArrowRight className="h-4 w-4 ml-2" /></a>
        </Button>
      </div>
      <div className="relative animate-fade-up" style={{ animationDelay: "0.15s" }}>
        <div className="rounded-3xl overflow-hidden shadow-2xl shadow-slate-300/50 border border-white">
          <img src={image} alt={imageAlt || title} className="w-full h-[400px] object-cover" />
        </div>
      </div>
    </div>
  </section>
);

export default PageHero;
